﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import VectorSource from 'ol/source/Vector.js';
import { Utility } from '../Utility.js';
export { UrbanismTool };

/**
 * Class Urbanism tool
 */
const UrbanismTool = function ()
{
    // Define this
    var myUrbanismTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Layer process information
    this._processLayerInfo = {}

    // -- end private variable --------------------------------------------------------------------


    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------


    // -- begin public method ---------------------------------------------------------------------

    /**
     * Execute action from adicional parameter
     */
    this.ExecuteAdicionalParameter = function ()
    {
        // Get adicional parameters
        var addicionalParams = myUrbanismTool._mapSgs._settings._mapSettings.additional_params;
        

        if (location.pathname === "/Maps/Processo" &&
            Object.keys(addicionalParams).find(c => c == "HashCode") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessType") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessNumber") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessYear") !== undefined
        ) {
            // Go to feature
            myUrbanismTool._GotoFeatureProcessNumber(addicionalParams.ProcessType, addicionalParams.ProcessNumber, addicionalParams.ProcessYear);
        } else if (location.pathname === "/Maps/ProcessoMedidata" &&
            Object.keys(addicionalParams).find(c => c == "HashCode") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessType") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessNumber") !== undefined &&
            Object.keys(addicionalParams).find(c => c == "ProcessYear") !== undefined
        )      {

                    var layerInfo = myUrbanismTool._mapSgs.layerTree.FindLayerInfoOnListLayer("PRETENSOES");

                    // Active layer police number
                    myUrbanismTool._mapSgs.layerTree.layerTreeObj.check(myUrbanismTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

                    myUrbanismTool._GotoPretensao(layerInfo, addicionalParams.id, addicionalParams.ProcessType, addicionalParams.ProcessYear, addicionalParams.ProcessNumber);


               }
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Goto process number
     * @param {string} processType, process type
     * @param {string} processNumber, process number
     * @param {string} processYear, process year
     */
    this._GotoFeatureProcessNumber = function (processType, processNumber, processYear)
    {
        // Start wait
        myUrbanismTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: myUrbanismTool._processLayerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": myUrbanismTool._processLayerInfo.workspace + ':' + myUrbanismTool._processLayerInfo.layerName,
                "cql_filter": myUrbanismTool._processLayerInfo.columnProcessType   + " == '" + processType + "' && " +
                              myUrbanismTool._processLayerInfo.columnProcessNumber + " == '" + processNumber + "/" + processYear + "'",
                'srsName': myUrbanismTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json',
                "maxFeatures": 200
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length === 1) {
                    myUrbanismTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[0]);
                    var styleElement = myUrbanismTool._mapSgs._defaultHighlighStyles;
                    myUrbanismTool._mapSgs.featureToHighLight.getArray()[myUrbanismTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                    // Set current features in overlay
                    myUrbanismTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myUrbanismTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    // Go to Feature
                    if(myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().length === 1 &&
                        (myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0].getGeometry().getType() === "Point" ||
                         myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0].getGeometry().getType() === "MultiPoint"
                        )
                      )
                    {
                        myUrbanismTool._mapSgs.map.getView().fit(myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myUrbanismTool._mapSgs.map.getSize(), maxZoom: 13, duration: 1000  });
                    }
                    else
                        myUrbanismTool._mapSgs.map.getView().fit(myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myUrbanismTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myUrbanismTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    /**
     * GotoPretensao
     * @param {any} layerInfo
     * @param {any} id
     * @param {any} Type
     * @param {any} Year
     * @param {any} Processo
     */

    this._GotoPretensao = function (layerInfo, id, Type, Year, Processo) {
        // Start wait
        myUrbanismTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "cql_filter": "TIPO == '" + Type + "' && " +
                    "PROCESSO == '" + Processo + "' &&" +
                    "ANO == '" + Year + "'",
                'srsName': myUrbanismTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length === 1) {
                    myUrbanismTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[0]);
                    var styleElement = myUrbanismTool._mapSgs._defaultHighlighStyles;
                    myUrbanismTool._mapSgs.featureToHighLight.getArray()[myUrbanismTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                    // Set current features in overlay
                    myUrbanismTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myUrbanismTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    myUrbanismTool._mapSgs.map.getView().fit(myUrbanismTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myUrbanismTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myUrbanismTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    // -- end event -------------------------------------------------------------------------------
}

/**
 * Init urbanism tool
 * @param {object} mapSgs, map object
 */
UrbanismTool.prototype.Init = function (mapSgs)
{
    if (!this._toolInitialize)
    {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;


        // Get layer process information
        var workspace = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "WORKSPACE");
        var layerName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "LAYER_NAME");
        var geoserver = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "GEOSERVER");
        var columnProcessType = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "COLUMN_PROCESS_TYPE");
        var columnProcessNumber = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "COLUMN_PROCESS_NUMBER");
        var columnProcessYear = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "COLUMN_PROCESS_YEAR");

        this._processLayerInfo = {
            workspace: (workspace===undefined)?"":workspace.value,
            layerName: (layerName===undefined)?"":layerName.value,
            geoserver: (geoserver===undefined)?"":geoserver.value,
            columnProcessType: (columnProcessType===undefined)?"":columnProcessType.value,
            columnProcessNumber: (columnProcessNumber===undefined)?"":columnProcessNumber.value,
            columnProcessYear: (columnProcessYear===undefined)?"":columnProcessYear.value
        };
    }
}